import FinanceFlowChart from "@components/FinanceFlowChart";
import styles from "./styles.module.scss";

export const ChartCFO = () => {
  return (
    <div className={styles.chartWrapper}>
      <FinanceFlowChart title={true} />
    </div>
  );
};
